exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[dir] ._39DTudgVQvnicsucCq6lOu{padding:15px}", ""]);

// exports
exports.locals = {
	"inspectorWrapper": "_39DTudgVQvnicsucCq6lOu"
};